import React from 'react';
import { tns } from 'tiny-slider/src/tiny-slider';
import { SitecoreImageField } from 'components/sitecore-fields';

class CompetitionListCarousel extends React.Component {
    constructor(props) {
        super(props);

        this.gallery = null;
        this.slides = React.createRef();
    }

    componentDidMount() {
        if (this.props.hasCarousel) {
            this.gallery = tns({
                container: this.slides.current,
                loop: false,
                nav: false,
                items: 1,
                gutter:20,
                controls: false
            });
            this.props.getNode(this.gallery);           
        }
    }

    componentWillUnmount() {
        if (this.gallery !== null) {
            this.gallery.destroy();
        }
    }

    render() {
        const { competitions, onClick } = this.props;
        return (
            <div className="competition-list__carousel--slides" ref={this.slides}>
                {
                    competitions.map((competition, index) => {
                        return (
                            <div key={index} className='competition-list__carousel--card-wrapper'>
                                <div className='competition-list__carousel-card'>
                                    {
                                        competition.image !== undefined && competition.image !== "" &&
                                        <div className='competition-list__carousel-card--bg'>
                                            <SitecoreImageField img={competition.image} className='competition-list__carousel-card--image' />
                                        </div>
                                    }
                                    <div className='competition-list__carousel-card--content-wrapper'>
                                        <div className='competition-list__carousel-card--tag'>{this.props.competitionTag}</div>
                                        <div className='competition-list__carousel-card--title'>
                                            {competition.title}
                                        </div>
                                        {
                                            competition.showLink &&
                                            <a className='competition-list__carousel-card--cta button button--primary' onClick={() => onClick(competition.competitionUrl)}>
                                                {competition.statusMessage}
                                            </a>
                                        }

                                        {
                                            competition.showLink === false &&
                                            <span className='competition-list__carousel-card--status'>{competition.statusMessage}</span>
                                        }
                                    </div>
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        );
    }
}

export default CompetitionListCarousel;
